import React from 'react';
import { formatCurrency, formatCurrencyWhole, fullCurrency } from '../../../utils/formatCurrency.js';


function AmountCard({ label, amount, icon, color, subAmount, subLabel, subAmount2, subLabel2, note, onClick, whole = true }) {
  const formatAmount = whole ? formatCurrencyWhole : formatCurrency;
  const titleAmount = whole ? formatCurrencyWhole : fullCurrency;
  const clickable = typeof onClick === 'function';
  return (
    <div
      className={`bg-white rounded-xl shadow-sm border border-gray-100 p-3 sm:p-4 hover:shadow-md transition-shadow relative min-h-[76px] sm:min-h-[90px] pr-10 sm:pr-14 ${
        clickable ? 'cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-teal-500' : ''
      }`}
      onClick={clickable ? onClick : undefined}
      onKeyDown={clickable ? (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick(e);
        }
      } : undefined}
      role={clickable ? 'button' : undefined}
      tabIndex={clickable ? 0 : undefined}
    >
      <p className="text-gray-500 text-[11px] sm:text-sm font-medium leading-snug break-words pr-1">{label}</p>
      <p className="text-base sm:text-xl font-bold text-gray-900 mt-1" title={titleAmount(amount)}>
        {formatAmount(amount)}
      </p>
      {subLabel && subAmount !== undefined && (
        <p className="text-[11px] sm:text-sm text-green-600 mt-0.5 sm:mt-1 font-medium break-words" title={titleAmount(subAmount)}>
          {subLabel}: {formatAmount(subAmount)}
        </p>
      )}
      {subLabel2 && subAmount2 !== undefined && (
        <p className="text-[11px] sm:text-sm text-orange-600 mt-0.5 font-medium break-words" title={titleAmount(subAmount2)}>
          {subLabel2}: {formatAmount(subAmount2)}
        </p>
      )}
      {note ? (
        <p className="text-[11px] sm:text-sm text-gray-600 mt-0.5 font-medium break-words">{note}</p>
      ) : null}
      <div className={`p-1.5 sm:p-2 absolute rounded-lg right-2 bottom-2 sm:right-3 sm:bottom-3 ${color}`}>
        {icon}
      </div>
    </div>
  );
}

export default AmountCard;
